<template>
    <QueryEventContentDetail
        v-if="slug"
        v-slot="{ eventContent }"
        :slug="slug"
    >
        <TemplatePanel
            v-if="eventContent"
            class="event-detail"
        >
            <template #default>
                <!-- Hero -->
                <EventContentHero :event-content="eventContent" />

                <!-- Quote -->
                <BaseSection
                    v-if="eventContent.curatorQuote"
                    width="content-sm"
                    color-theme="light"
                >
                    <BaseTestimonial
                        :content="eventContent.curatorQuote"
                        :image="eventContent.curator?.featuredImage"
                        :author="eventContent.curator?.name"
                        :title="eventContent.curator?.sub_title"
                    />
                </BaseSection>

                <!-- Description -->
                <FlexibleSectionRichText
                    v-if="eventContent.description"
                    color-theme="light"
                    :rich-text="getDescription(eventContent.description)"
                />

                <QueryUpdates
                    v-if="eventContent.id"
                    v-slot="{ entries }"
                    :event-content="[eventContent.id]"
                >
                    <BaseSection
                        v-if="entries && entries.length > 0"
                        data-width="content-sm"
                        color-theme="light"
                    >
                        <ArticleCard :entry="entries[0]" />
                    </BaseSection>
                </QueryUpdates>

                <!-- Trailer -->
                <FlexibleSectionTheVideo
                    v-if="eventContent.trailerUrl"
                    color-theme="light"
                    :video-url="eventContent.trailerUrl"
                    :caption="getTrailerCaption(eventContent)"
                />

                <EventRelationList
                    :artists="eventContent.artists"
                    :production-house="eventContent.productionHouse"
                />

                <EventCta :ctas="filterCtas(ctas, 'eventContent')" />
            </template>

            <template #related>
                <!-- Related content can be added here -->
            </template>
        </TemplatePanel>
    </QueryEventContentDetail>
</template>

<script setup lang="ts">


const { slug } = defineProps<{
    slug: string;
}>();

const ctas = useCta();

const getDescription = (text: string) => {
    return `<h2>Over dit programma</h2>${text}`;
};

const getTrailerCaption = (event: EventContentDetailData) => {
    let caption = event.trailerCaption || '';

    if (event.trailerCredits && event.trailerCaption) {
        caption += ` - ${event.trailerCredits}`;
    }

    if (event.trailerCredits && !event.trailerCaption) {
        caption = event.trailerCredits;
    }

    return caption;
};
</script>